import gcLightJson from '../../../../../assets/trail/chewy-mega-dice-light-gc.json';
import gcLight from '../../../../../assets/trail/chewy-mega-dice-light-gc.webp';
import scLightJson from '../../../../../assets/trail/chewy-mega-dice-light-sc.json';
import scLight from '../../../../../assets/trail/chewy-mega-dice-light-sc.webp';
import { SpriteAnimation } from '../../../../../components/EventTriggerDialog/road/components/SpriteAnimation/SpriteAnimation';
import { type SpriteSheetAsset, useSpriteSheet } from '../../../../../hooks/useSpriteSheet';
import type { CoinType } from '../../../../../stores/cointype/CoinTypeStore';

import styles from './MegaDiceLight.module.scss';

// Yellow lightning on Gold Coins, green on Sweeps Coins
const MEGA_DICE_LIGHT_SPRITES: Record<CoinType, SpriteSheetAsset> = {
  GC: { imageSrc: gcLight, dataSrc: JSON.stringify(gcLightJson) },
  SC: { imageSrc: scLight, dataSrc: JSON.stringify(scLightJson) },
};

const FRAME_INTERVAL_MS = 1000 / 30;

interface MegaDiceLightProps {
  coinType: CoinType;
}

// Chewy's looping lightning over his trail widget art while he holds Mega Dice
export function MegaDiceLight({ coinType }: MegaDiceLightProps) {
  const sprite = useSpriteSheet(MEGA_DICE_LIGHT_SPRITES[coinType]);

  if (!sprite.ready) {
    return null;
  }

  return <SpriteAnimation className={styles.light} frameInterval={FRAME_INTERVAL_MS} sprite={sprite} />;
}
